module.exports = __webpack_public_path__ + "img/chen.77992e55.png";